module.exports = __webpack_public_path__ + "media/images/front/materials/metal-82636cd4e8d1f0118731700021fb245b.jpg";